var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',[_c('general-expansion-panel'),_c('filters-expansion-panel'),_c('serasa-expansion-panel'),_c('erp-expansion-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }